/**
 * Cleans up the locale date string in order to remove unecessary characters
 * generated by the browser.
 * @param string
 */
export const cleanUpLocaleDateString = (stringToCleanup: string) => {
    /**
     * Executing toLocaleDateString returns 'XX, Central European Time'. Since we know that there are
     * 2 characters and a comma before the part that we are interested in, we do a slice(2) and a replace in order to retrieve the actual text.
     */
    return stringToCleanup.slice(2).replace(',', '').replace(' ', '');
};
